export const RC_BALANCE_HEALTH_FAX_NUMBER = "+18014786239";
export const RC_BALANCE_HEALTH_FAX_NUMBER_2 = "+18586666839";
export const RC_BALANCE_HEALTH_ARTISAN_FAX_NUMBER = "+19495227039";
export const RC_BALANCE_HEALTH_DESERT_FAX_NUMBER = "+14809442817";
export const RC_BALANCE_HEALTH_IFAC_FAX_NUMBER = "+14253201747";
export const RC_BALANCE_HEALTH_WFAI_FAX_NUMBER = "+18477379586";
export const RC_BALANCE_HEALTH_FCC_FAX_NUMBER = "+14062067833";
export const RC_BALANCE_HEALTH_FAC_ROCKIES_FAX_NUMBER = "+13033735069";
export const RC_BALANCE_HEALTH_1F2F_FAX_NUMBER = "+19482081196";
export const RC_BALANCE_HEALTH_FASWM_FAX_NUMBER = "+16163178759";
export const RC_BALANCE_HEALTH_LVFAC_FAX_NUMBER = "+17023024819";
export const RC_BALANCE_HEALTH_UFAI_FAX_NUMBER = "+18053248256";
export const RC_BALANCE_HEALTH_PRECISION_FAX_NUMBER = "+14242728829";
export const RC_BALANCE_HEALTH_BAFC_FAX_NUMBER = "+14153766746";
export const RC_BALANCE_HEALTH_SFAC_FAX_NUMBER = "+19167602346";
export const RC_BALANCE_HEALTH_PPO_FAX_NUMBER = "+19167605137";
export const RC_BALANCE_HEALTH_VPG_FAX_NUMBER = "+12093952643";

export const RC_BALANCE_HEALTH_PORTED_FAX_NUMBER_TO_EXISTING_FAX_NUMBER: Readonly<Record<string, string>> = {
  "+18336001541": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336001538": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18339733739": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18333741418": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334493739": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556171543": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18335992495": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336380232": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18335650426": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18337603932": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18339725269": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18339735219": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336001537": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18339735352": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334490753": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556171544": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334385675": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556211883": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334643590": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18339735353": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334385671": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336001535": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18337412639": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18337646156": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556825351": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18339733740": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336001531": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336152399": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334642415": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334505918": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336001543": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334714945": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18339733959": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334714131": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556171547": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18333912173": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18333741417": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556171595": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18336060181": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556211890": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18556212004": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334494365": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334643543": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334512201": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334500791": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334500792": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18334643542": RC_BALANCE_HEALTH_BAFC_FAX_NUMBER,
  "+18552479802": RC_BALANCE_HEALTH_PPO_FAX_NUMBER,
  "+18339052580": RC_BALANCE_HEALTH_PPO_FAX_NUMBER,
  "+18334494007": RC_BALANCE_HEALTH_PPO_FAX_NUMBER,
  "+18339052581": RC_BALANCE_HEALTH_PPO_FAX_NUMBER,
  "+18339740955": RC_BALANCE_HEALTH_PPO_FAX_NUMBER,
  "+18334412278": RC_BALANCE_HEALTH_SFAC_FAX_NUMBER,
  "+18556177438": RC_BALANCE_HEALTH_SFAC_FAX_NUMBER,
  "+18556177710": RC_BALANCE_HEALTH_SFAC_FAX_NUMBER,
  "+18335812409": RC_BALANCE_HEALTH_SFAC_FAX_NUMBER,
  "+18339732757": RC_BALANCE_HEALTH_VPG_FAX_NUMBER,
  "+18334715462": RC_BALANCE_HEALTH_VPG_FAX_NUMBER,
  "+18018028585": RC_BALANCE_HEALTH_FAX_NUMBER,
  "+18339744744": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18338070124": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18334500207": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18337603906": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18446704653": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18446704693": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18338070125": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18339735218": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18334381472": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18334284525": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+18339735347": RC_BALANCE_HEALTH_FAX_NUMBER_2,
  "+19492899805": RC_BALANCE_HEALTH_ARTISAN_FAX_NUMBER,
  "+18335932772": RC_BALANCE_HEALTH_ARTISAN_FAX_NUMBER,
  "+18335932770": RC_BALANCE_HEALTH_ARTISAN_FAX_NUMBER,
  "+18336512522": RC_BALANCE_HEALTH_DESERT_FAX_NUMBER,
  "+18334505276": RC_BALANCE_HEALTH_IFAC_FAX_NUMBER,
  "+18337643251": RC_BALANCE_HEALTH_IFAC_FAX_NUMBER,
  "+18337645065": RC_BALANCE_HEALTH_IFAC_FAX_NUMBER,
  "+18338030112": RC_BALANCE_HEALTH_IFAC_FAX_NUMBER,
  "+18474188950": RC_BALANCE_HEALTH_WFAI_FAX_NUMBER,
  "+14062858399": RC_BALANCE_HEALTH_FCC_FAX_NUMBER,
  "+19702303627": RC_BALANCE_HEALTH_FAC_ROCKIES_FAX_NUMBER,
  "+19702303761": RC_BALANCE_HEALTH_FAC_ROCKIES_FAX_NUMBER,
  "+13033531780": RC_BALANCE_HEALTH_FAC_ROCKIES_FAX_NUMBER,
  "+13035867775": RC_BALANCE_HEALTH_FAC_ROCKIES_FAX_NUMBER,
  "+17203067217": RC_BALANCE_HEALTH_FAC_ROCKIES_FAX_NUMBER,
  "+17203067229": RC_BALANCE_HEALTH_FAC_ROCKIES_FAX_NUMBER,
  "+17575252556": RC_BALANCE_HEALTH_1F2F_FAX_NUMBER,
  "+16167238019": RC_BALANCE_HEALTH_FASWM_FAX_NUMBER,
  "+17024106668": RC_BALANCE_HEALTH_LVFAC_FAX_NUMBER,
  "+13103637619": RC_BALANCE_HEALTH_UFAI_FAX_NUMBER,
};

export function getBalanceHealthExistingFaxNumber(faxNumber: string): string {
  return RC_BALANCE_HEALTH_PORTED_FAX_NUMBER_TO_EXISTING_FAX_NUMBER[faxNumber] ?? faxNumber;
}
